<template>
    <el-popover placement="top-start" width="100" trigger="click">
        <!-- <el-button slot="reference">hover 激活</el-button> -->
        <div style=" text-align: center;cursor:pointer;background-color:#e0e0e0;padding: 10px;" @click="exitLogin">退出登陆
        </div>
        <div class="user" slot="reference">
            <span>{{ userInfo.nickname }}</span>
            <img :src="userInfo.avatar" alt="">
            <!-- <img :src="shiyan()" alt=""> -->
        </div>
    </el-popover>

    <!-- <div class="user">
        <span>{{ userInfo.nickname }}</span>
        <img :src="userInfo.avatar" alt="">
    </div> -->
</template>
<script>
import request from '../utils/request';

export default {
    name: "userInfo",
    data() {
        return {
            property: 'value',
        };
    },
    methods: {
        async exitLogin() {
            const res = await request({
                url: 'admin/user/exit',
                method: 'GET'
            })
            if (res.code === '200') {
                this.$notify({
                    title: res.message,
                    type: 'success'
                });
            }
            sessionStorage.removeItem("authorization");
            this.$store.dispatch('deleteState')
            this.$router.push("/");
            // this.$notify({
            //     title: '退出成功',
            //     type: 'success'
            // });
        },
        // shiyan() {
        //     return "https://www.weidazhizao.com/uniform/file/good/邹城11校服.jpg"
        // }

    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo
        }
    },
    created() {
        //console.log(this.$store.state);
        // //console.log(this.userInfo);
    }
}
</script>
<style lang="scss" scoped>
.user {
    width: 100%;
    height: 60px;
    line-height: 60px;
    padding-right: 20px;

    span {
        margin-right: 20px;
    }

    img {
        width: 50px;
        height: 50px;
        padding-top: 5px;
        border-radius: 50%;
        vertical-align: middle
    }
}
</style>